import angular from 'angular';

export class ScrollService {
  constructor() {
  }

  mainScrollContainerElement() {
    return angular.element('.alc-content-scroll-container');
  }

  scrollMainContainerTo(scrollTop, delay) {
    if (delay) {
      this.mainScrollContainerElement().animate({
        scrollTop: scrollTop
      }, delay);  
    } else {
      this.mainScrollContainerElement()[0].scrollTop = scrollTop;
    }
  }

  scrollContainerToElement(container, topOfContent, element, correction, delay) {
    const scrollTop = element.offset().top - topOfContent.offset().top - correction;
    if (delay) {
      container.animate({
        scrollTop: scrollTop
      }, delay);  
    } else {
      container[0].scrollTop = scrollTop;
    }
  }

  scrollContainerDelta(container, delta) {
    container[0].scrollTop = container[0].scrollTop + delta;
  }

  scrollMainContainerToTop() {
    this.scrollMainContainerTo(0, 0);
  }
  scrollMainContainerToBottom() {
    this.scrollMainContainerTo(this.mainScrollContainerElement()[0].scrollHeight, 0);
  }


  static ScrollFactory() {
    return new ScrollService();
  }
}
ScrollService.ScrollFactory.$inject = [];
